import cx from 'classix';
import Image from 'next/image';

// import {
//   useCallback,
//   useState,
// } from 'react';
//
// import Skeleton from '@/ui/skeleton/skeleton';
import styles from './listing-carousel-slide.module.scss';

interface ListingCarouselSlideProps {
  src: string;
  alt: string;
  index: number;
  // inView: boolean;
}

// const PLACEHOLDER_SRC = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D';

export default function ListingCarouselSlide(props: ListingCarouselSlideProps) {
  const {
    alt,
    index,
    src,
  } = props;
  // const [hasLoaded,
  //   setHasLoaded] = useState(false);
  //
  // const setLoaded = useCallback(() => {
  //   setHasLoaded(true);
  // }, [setHasLoaded]);

  const url = new URL(src);
  url.searchParams.set('auto', 'webp');
  url.searchParams.set('width', (372).toString());
  url.searchParams.set('quality', (30).toString());

  return (
    <div className={styles.embla__slide}>
      {/* <img */}
      {/*   className={cx(styles.embla__slide__img)} */}
      {/*   src={src} */}
      {/*   alt={alt} */}
      {/* /> */}
      <Image
        className={cx(styles.embla__slide__img)}
        src={url.toString()}
        alt={alt}
        width={372}
        height={279}
        quality={25}
        priority={index === 0}
        unoptimized
          // onLoad={setLoaded}
          // data-src={src}
      />
      {/* <div */}
      {/*   className={cx( */}
      {/*     styles.embla__lazyLoad, */}
      {/*     hasLoaded && styles.embla__lazyLoad__hasLoaded, */}
      {/*   )} */}
      {/* > */}
      {/*   {!hasLoaded && ( */}
      {/*     <div className={styles.carousel_skeleton}> */}
      {/*       <Skeleton /> */}
      {/*     </div> */}
      {/*   )} */}

      {/*   <Image */}
      {/*     className={cx(styles.embla__slide__img, styles.embla__lazyLoad__img)} */}
      {/*     src={hasLoaded ? src : PLACEHOLDER_SRC} */}
      {/*     alt={alt} */}
      {/*     fill */}
      {/*     // onLoad={setLoaded} */}
      {/*     quality={25} */}
      {/*     data-src={src} */}
      {/*   /> */}
      {/* </div> */}
    </div>
  );
}
